import React, {useState,useEffect} from 'react'
import styled from 'styled-components'
import Context from './context.js' 
import theme from './theme.js'
import media from './theme-media.js'
import '../style/index.css'
import GlobalStyle from '../style/global.js'
import ActionBar from './layout-action-bar.js'
import setActionBar from '../functions/set-action-bar.js'
import Search from './search.js'
import site from '../../data/site.mjs'
import getData from '../functions/format-page-data.js'
import Header from './header.js'
import Footer from './footer.js'

const App = context => {
  const data = getData(context)
  const children = context.children
  const location = context.location

  const page = data?.page || {}
  const search = {}

  const [actionBarIsActive,setActionBarIsActive] = useState(false)
  const [actionBarText,setActionBarText] = useState('')
  const [searchIsActive,setSearchIsActive] = useState(false)
  const [searchText,setSearchText] = useState('')
  const [searchResults,setSearchResults] = useState([])
  const [activeSearchPages,setActiveSearchPages] = useState([])

  const siteProps = {
    title: site.title,
    actionBarText
  }

  const hideActionBar = () => setActionBarIsActive(false)
  const showActionBar = () => setActionBarIsActive(true)

  const actionBar = {
    isActive: actionBarIsActive,
    text: actionBarText,
    hide: () => setActionBarIsActive(false),
    show: () => setActionBarIsActive(true),
    setText: text => setActionBar({text,setActionBarText,setActionBarIsActive,hideActionBar,showActionBar})
  }

  search.isActive = searchIsActive
  search.show = () => setSearchIsActive(true)
  search.hide = () => setSearchIsActive(false)
  search.toggle = () => setSearchIsActive(!searchIsActive)
  search.text = searchText
  search.setResults = setSearchResults
  search.setText = text => setSearchText(text.toLowerCase())
  search.pages = activeSearchPages
  search.results = searchResults
  search.setActivePages = pages => setActiveSearchPages(pages)

  const handleKeyPress = event => {
    if (event.key === 'Escape') {
      if (searchIsActive) {
        setSearchIsActive(false)
      }
    }

    if (event.metaKey && event.key === 'p') {
      event.preventDefault()
      setSearchIsActive(true)
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress)
  },[])

  useEffect(() => {
    setSearchIsActive(false)
  },[location.pathname])

  const app = {
    data,
    page,
    search,
    site: siteProps,
    actionBar
  }

  return (
    <Context.Provider value={app}>
      <Body>
        <GlobalStyle/>
        <div>
          <Search/> 
          <ActionBar/>
          <Header/>
          {children}
          <Footer/>
        </div>
      </Body>
    </Context.Provider>
  )
}

const Body = styled.div`
  --padding-horizontal: ${theme.padding.small};

  font-family: ${theme.font.family.primary};
`

export default App